module.exports = __webpack_public_path__ + "static/media/instagram-tile.4e2dacf3.svg";